import { opsApi } from "API";
import { RoleSummary } from "../types/RoleSummary";

export const getTeamRolesApi = async (): Promise<RoleSummary[]> => {
    const res = await opsApi.graphQLQuery<GraphQLPayload>(query, {});
    return res.data.teamRoles;
};

type GraphQLPayload = { roles: RoleSummary[] };

const query = `
    query {
        teamRoles {
            shortName,
            displayName,
            description,
            userType
        }
    }
`;
